import Controller from '@ember/controller';
import { action } from '@ember/object';
import { type Registry as Services, service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import type Ota from 'frontend-utils/models/ota';
import { OTA_IDS } from 'frontend-utils/utils/constants/constant-values';
import type HotelSettingsCentralMappingChannelRoomCategoriesRoute from 'lumen/routes/hotel/settings/central-mapping/channel-room-categories';
import { CHANNEL_ROOM_MAPPING_PRODUCTS } from 'lumen/utils/central-mapping-constants';
import type { ModelFrom } from 'lumen/utils/routes';

export default class HotelSettingsCentralMappingChannelRoomCategoriesController extends Controller {
  declare model: ModelFrom<HotelSettingsCentralMappingChannelRoomCategoriesRoute>;
  queryParams = ['ota'];
  @service declare access: Services['access'];
  @service declare store: Services['store'];

  @tracked ota = '';

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get canSelectOTA() {
    return this.access.hasRates || this.access.hasPricingAssistantTab;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get dataType() {
    if (this.ota === OTA_IDS.ALL_CHANNELS) {
      return CHANNEL_ROOM_MAPPING_PRODUCTS.PARITY;
    }
    return CHANNEL_ROOM_MAPPING_PRODUCTS.ALL_PRODUCTS;
  }

  get isRatePreferenceLoading(): boolean {
    return Boolean(this.model.ratePreferenceTaskResult?.isRunning);
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get isRoomtypeRequestLoading() {
    return Boolean(this.model.roomtypes.isRunning);
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get roomtypes() {
    return this.model.roomtypes.value;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get selectedOTA() {
    return this.store.peekRecord<Ota>('ota', this.ota);
  }

  @action chooseOTA(ota: Ota): void {
    this.ota = ota.id as string;
  }

  @action doRefresh(): void {
    this.send('refreshRoute');
  }
}
